import aboutImage from '../assets/shinpinkakou.jpg';

function About() {
  const uses = [
    {
      number: '01',
      label: 'STORE',
      title: '店舗・テイクアウト',
    },
    {
      number: '02',
      label: 'OFFICE',
      title: '事務所・休憩所',
    },
    {
      number: '03',
      label: 'STORAGE',
      title: '資材・在庫保管',
    },
    {
      number: '04',
      label: 'PRIVATE',
      title: '趣味空間・ガレージ',
    },
  ];

  return (
    <section className="section about-section" id="about">
      <div className="container">
        <div className="about-editorial reveal">
          <figure className="about-editorial__media">
            <img src={aboutImage} alt="加工されたコンテナ" />
          </figure>

          <div className="about-editorial__content">
            <p className="section-label">POSSIBILITIES</p>
            <h2 className="section-title">コンテナの可能性</h2>
            <p className="about-editorial__lead">
              保管するだけではなく、<br />
              働く場所、売る場所、過ごす場所へ。<br />
              コンテナは、用途に合わせて姿を変える空間です。
            </p>

            <ol className="about-use-list">
              {uses.map((item) => (
                <li className="about-use-list__item" key={item.number}>
                  <span className="about-use-list__number">{item.number}</span>
                  <span className="about-use-list__label">{item.label}</span>
                  <span className="about-use-list__title">{item.title}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
